import React, { useState, useEffect } from "react";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import withRouter from "../../../components/Common/withRouter";
import {
  Badge,
  Button,
  CardText,
  Col,
  Container,
  Row,
  Table,
  Spinner,
} from "reactstrap";
import { useNavigate, useParams } from "react-router-dom";

const ViewCorporateOrder = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const baseurl = process.env.REACT_APP_BASE_URL;
  const imgurl = process.env.REACT_APP_IMAGE_URL;
  document.title = "Order details | Vekart";

  const [loading, setLoading] = useState(true);
  const [orderData, setOrderData] = useState(null);

  useEffect(() => {
    fetch(`${baseurl}/admin/customer/order-detail/${id}`)
      .then((res) => res.json())
      .then((res) => {
        if (res.success) {
          setOrderData(res.data);
        }
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error loading order:", err);
        setLoading(false);
      });
  }, [id]);

  if (loading) {
    return (
      <div className="page-content text-center mt-5">
        <Spinner color="primary" />
        <p>Loading order details...</p>
      </div>
    );
  }

  if (!orderData) {
    return (
      <div className="page-content text-center mt-5">
        <h4>Order not found</h4>
        <Button color="primary" onClick={() => navigate(-1)}>
          Back
        </Button>
      </div>
    );
  }

  const { order, billingAddress, shippingAddress, items, summary } = orderData;
const isIntraState =
  billingAddress?.state?.toLowerCase() === "gujarat";
  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumbs title="Orders" breadcrumbItem="Order details" />

        <Button
          type="button"
          color="primary"
          className="btn mb-3 me-2 d-flex align-items-center"
          onClick={() => navigate(-1)}
        >
          <i className="bx bx-arrow-back me-1"></i>
          Back to Orders
        </Button>

        {/* ORDER DETAILS CARD */}
        <div className="card" style={{ border: "1px solid #e9ebec" }}>
          <div className="card-body">
            <h4 className="mb-1 text-muted fw-bold">
              Order details - {order.order_id}
            </h4>
            <p className="text-muted mb-0">
              Payment via {order.payment_mode || "N/A"} - {order.payment_status || "N/A"}
            </p>

            <Row className="mt-4">
              {/* User Info */}
              <Col md="4">
                <CardText>
                  <strong>User ID:</strong> #{order.user_id}
                </CardText>
                <CardText>
                  <strong>User Name:</strong> {order.username}
                </CardText>
                <CardText>
                  <strong>Mobile:</strong> {order.usermobile_number}
                </CardText>
                <CardText>
                  <strong>Email:</strong> {order.useremail}
                </CardText>
                <CardText>
                  <strong>Order Date:</strong> {order.created_at}
                </CardText>
                <CardText>
                  <strong>Order Status:</strong>{" "}
                  <Badge color="info">{order.order_status}</Badge>
                </CardText>
                <CardText>
                  <strong>Payment Status:</strong>{" "}
                  <Badge color="warning">{order.payment_status}</Badge>
                </CardText>
              </Col>

              {/* Billing Address */}
              <Col md="4">
                <h6 className="fw-bold">Billing Address</h6>
                <CardText>{billingAddress.full_name}</CardText>
                <CardText>{billingAddress.address}</CardText>
                <CardText>
                  {billingAddress.city}, {billingAddress.state} -{" "}
                  {billingAddress.pincode}
                </CardText>
                <CardText>{billingAddress.mobile_no}</CardText>
              </Col>

              {/* Shipping Address */}
              <Col md="4">
                <h6 className="fw-bold">Shipping Address</h6>
                <CardText>{shippingAddress.full_name}</CardText>
                <CardText>{shippingAddress.address}</CardText>
                <CardText>
                  {shippingAddress.city}, {shippingAddress.state} -{" "}
                  {shippingAddress.pincode}
                </CardText>
                <CardText>{shippingAddress.mobile_no}</CardText>
              </Col>
            </Row>
          </div>
        </div>

        {/* PRODUCTS LIST */}
        <div className="card mt-3" style={{ border: "1px solid #e9ebec" }}>
          <div className="card-body">
            <h5 className="mb-3">Products in this Order</h5>

            <table className="table table-bordered align-middle" style={{ tableLayout: "fixed", width: "100%" }}>
  <thead className="table-light">
    <tr>
      <th style={{ width: "3%" }}>#</th>
      <th style={{ width: "8%" }}>Image</th>
      <th style={{ width: "30%" }}>Product</th>
      <th style={{ width: "8%" }} className="text-end">Price</th>
      <th style={{ width: "7%" }} className="text-center">Qty</th>
      <th style={{ width: "5%" }} className="text-center">Discount (%)</th>
      <th style={{ width: "10%" }} className="text-end">Discount Price</th>
      {isIntraState ? (
      <>
        <th style={{ width: "8%" }} className="text-end">CGST</th>
        <th style={{ width: "8%" }} className="text-end">SGST</th>
      </>
    ) : (
      <th style={{ width: "16%" }} className="text-end">IGST</th>
    )}
      <th style={{ width: "13%" }} className="text-end">Sub Total</th>
    </tr>
  </thead>

                                          <tbody>
                                            {orderData.items?.length > 0 ? (
                                              orderData.items.map((product, index) => {
                                                const price = Number(product.price) || 0;
                                                const qty = Number(product.quantity) || 0;
                                                const discount = Number(product.discount) || 0;
                                                const igst = Number(product.igst) || 0;
                    
                                                const discountedPrice = price - (price * discount) / 100;
                                                const itemSubtotal = discountedPrice * qty;
                                                const taxAmount = itemSubtotal * (igst / 100);
                                                const rowTotal = itemSubtotal + taxAmount;
                                                const taxableValue = (price - (price * discount) / 100) * qty;

                                                const cgstRate = Number(product.cgst) || 0;
                                                const sgstRate = Number(product.sgst) || 0;
                                                const igstRate = Number(product.igst) || 0;

                                                const cgstAmount = taxableValue * (cgstRate / 100);
                                                const sgstAmount = taxableValue * (sgstRate / 100);
                                                const igstAmount = taxableValue * (igstRate / 100);

                                                const total = isIntraState ? taxableValue + cgstAmount + sgstAmount : taxableValue + igstAmount;
                                                
                                                return (
                                                  <tr key={product.id || index}>
                                                    <td>{index + 1}</td>
                                                    <td>
                                                      <img
                                                        src={product.fileurl ? `${imgurl}${product.fileurl}` : "/images/no-image.png"}
                                                        alt="product-img"
                                                        title="product-img"
                                                        className="avatar-md"
                                                      />
                                                    </td>
                                                    <td>
                                                      <h5 className="font-size-14 ">
                                                       
                                                          {product?.product_name}
                                                      </h5>
                                                      
                                                    </td>
                                                    <td className="text-end">₹ {price.toFixed(2)}</td>
                                                    <td className="text-center">{qty}</td>
                                                    <td className="text-center">{discount} %</td>
                                                    <td className="text-end">₹ {discountedPrice.toFixed(2)}</td>
                                                    {isIntraState ? (
                                                              <>
                                                                <td className="text-end">
                                                                  ₹ {cgstAmount.toFixed(2)} <br />
                                                                  <small className="text-muted">({cgstRate}%)</small>
                                                                </td>
                                                                <td className="text-end">
                                                                  ₹ {sgstAmount.toFixed(2)} <br />
                                                                  <small className="text-muted">({sgstRate}%)</small>
                                                                </td>
                                                              </>
                                                            ) : (
                                                              <td className="text-end">
                                                                ₹ {igstAmount.toFixed(2)} <br />
                                                                <small className="text-muted">{igstRate}%</small>
                                                              </td>
                                                            )}
                                                    <td className="text-end fw-semibold">₹ {rowTotal.toFixed(2)}</td>
                    
                                                    
                                                  </tr>
                                                );
                                              })
                                            ) : (
                                              <tr>
                                                <td colSpan={9} className="text-center">
                                                  No Data Found
                                                </td>
                                              </tr>
                                            )}
                                          </tbody>
                  </table>
          </div>
        </div>

        {/* SUMMARY CARD */}
        <Row className="mt-3">
          <Col md="8">
          <CardText>
                                  <strong>Delivery Schedule:</strong>
                                </CardText>
                                <CardText>
                                  {orderData.order.schedule_type}
                                </CardText>
                          
          </Col>

          <Col md="4">
            <div className="card" style={{ border: "1px solid #e9ebec" }}>
              <div className="card-body">
                <h5 className="mb-3 fw-bold">Order Summary</h5>

                <Table className="table mb-0">
                                          <tbody>
                                            <tr>
                                              <td>Grand Total :</td>
                                              <td>₹ {orderData.summary.subtotal}</td>
                                            </tr>
                                            
                                            <tr>
                                              <td>Shipping Charge :</td>
                                              <td>₹ {orderData.order.shipping_charge}</td>
                                            </tr>
                                            <tr>
                                              <td>Estimated Tax : </td>
                                              <td>₹ {orderData.order.shipping_cgst + orderData.order.shipping_sgst + orderData.order.shipping_igst}</td>
                                            </tr>
                                            <tr>
                                              <th>Total :</th>
                                              <th>₹ {orderData.order.total_amount}</th>
                                            </tr>
                                          </tbody>
                                        </Table>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default withRouter(ViewCorporateOrder);
